export default "__VITE_ASSET__ChAKO_Wg__"